import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./membershipFee.css";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import dayjs from 'dayjs';
import Swal from "sweetalert2";
import { fetchSubscriptionData, getmemberShipTypeList, getSubscriptionCodeStatus, membershipFeeInsert } from "../../services/master.service";
import AlertConfirmation from "../../common/AlertConfirmation.component";
import ConfirmationDialog from "../header/confirmation.dialog";
import { SnackbarUI, useSnackbar } from "../header/snackbarProvider";
import SelectPicker from "../selectpicker/selectPicker";
const MembershipFeeComponent = () => {
  const [memberships, setMemberships] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [isAddMode, setIsAddMode] = useState(false);
  const [actionFrom, setActionFrom] = useState("Add");
  const [dialogValues, setDialogValues] = useState({});
  const [isEditable, setIsEditable] = useState(true);
  const [editData, setEditData] = useState([]);
  const [isDuplicate, setIsDuplicate] = useState(false);
  
    const [openFeeConfirmationDialog, setOpenFeeConfirmationDialog] = useState(false);
      const { showSnackbar, snackbar } = useSnackbar();

    const handleFeeDialogClose = () => {
      setOpenFeeConfirmationDialog(false);
    };

  const [initialValues, setInitialValues] = useState({
    subscriptionName: "",
    subscriptionAmount: "",
    subscriptionType: "",
    subscriptionCode:""
  });

  const validationSchema = Yup.object().shape({
    subscriptionName: Yup.string().required("Membership Name is required"),
    subscriptionCode: Yup.string()
    .matches(/^[A-Za-z]{2,}$/, "Membership Code must be at least 2 letters and contain only alphabets")
    .required("Membership Code is required"),
    subscriptionAmount: Yup.number()
    .typeError("Only numbers are allowed")
    .required("Amount is required")
    .min(0, "Minimum value must be 0 or greater"),
    subscriptionType: Yup.string().required("Membership Type is required"),
  });

  const toggleModal = (action) => {
    setActionFrom(action);
    if (action === 'Add') {
        setIsAddMode(true);
        setInitialValues(({
            subscriptionName: "",
            subscriptionAmount: "",
            subscriptionType: "",
            subscriptionCode:""
        }));
    } else {
        setIsAddMode(false)
    }
    setShowModal(!showModal);
    if (!showModal) {
        setModalVisible(true)
    } else {
        setModalVisible(false);
    }
  };

  useEffect(() => {
    memberTypeList();
  }, []);

  const memberTypeList = async () => {
    try {
      const memberShipTypeList = await getmemberShipTypeList();
      setMemberships(memberShipTypeList);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {

    }
  };

  const handleEditClick = async (item) => {
    const editData = await fetchSubscriptionData(item.subscriptionId);
    setEditData(editData);
    setInitialValues(editData);
    setActionFrom('Edit');
    toggleModal('Edit');
  };


  const handleSubmit = async (values) => {
        setOpenFeeConfirmationDialog(true)
        setDialogValues(values);
  }

  const handleFeeInfoDialogConfirm = async () => {
    setOpenFeeConfirmationDialog(false);
    const successMessage = isAddMode ? "Membership Type Added Successfully!" : "Membership Type Updated Successfully!";
    const unsuccessMessage = isAddMode ? "Membership Type Add Unsuccessful!" : "Membership Type Update Unsuccessful!";

            try {
                const result = await membershipFeeInsert(dialogValues);
                if (result != null) {
                    await memberTypeList();
                    setShowModal(false);
                    setInitialValues('');
                    showSnackbar(
                      successMessage,
                      "success"
                    );
                } else {
                  showSnackbar(
                    unsuccessMessage,
                    "error"
                  );
                }
            } catch (error) {
                console.error('Error Adding Iqa:', error);
                Swal.fire('Error!', 'There was an issue inserting IQA the auditor.', 'error');
            }
};

const subscriptionDurationOptions = [
  { value: "A", label: "Annual" },
  { value: "L", label: "Lifetime" },
];

const checkSubscriptionCodeStatus = async (subscriptionCode) => {
  try {
    const status = await getSubscriptionCodeStatus(subscriptionCode);
    if (status === "USED") {
      setIsEditable(false);
    } else {
      setIsEditable(true);
    }
  } catch (err) {
    console.error("Failed to check subscription code status:", err);
    setIsEditable(true);
  }
};

useEffect(() => {
  if (modalVisible && initialValues.subscriptionCode) {
    checkSubscriptionCodeStatus(initialValues.subscriptionCode);
  }
}, [modalVisible, initialValues.subscriptionCode]);


const handleSubscriptionCodeBlur = async (e, setFieldValue, setFieldError) => {
  const value = e.target.value;
  setFieldValue("subscriptionCode", value);
  const memberList = await getmemberShipTypeList();
  const isDuplicate = memberList.some((item) => {
    const existingCode = item.subscriptionCode.toUpperCase();
    if (actionFrom === 'Edit') {
      return existingCode === value.toUpperCase() && existingCode !== editData.subscriptionCode.toUpperCase();
    } else {
      return existingCode === value.toUpperCase();
    }
  });
  setIsDuplicate(isDuplicate);
  if (isDuplicate) {
    setFieldError("subscriptionCode", "This Membership Code already exists.");
  } else {
    setFieldError("subscriptionCode", "");
  }
};


  return (
    <div className="table-wrap container">
      <main>
        <div className="subscription-title mb-4">
          <h1>Membership Fee List</h1>
        </div>
            {snackbar.open && <SnackbarUI message={snackbar.message} type={snackbar.type} />}
        
        <div id="card-body customized-card">
        <div className="table-container">
        <table className="membership-table">
            <thead>
              <tr>
                <th className="masterHeader"  style={{ width: "5%" }}>SN</th>
                <th className="masterHeader"  style={{ width: "20%" }}>Membership  Code</th>
                <th className="masterHeader"  style={{ width: "20%" }}>Membership  Name</th>
                <th className="masterHeader"  style={{ width: "20%" }}>Type</th>
                <th className="masterHeader"  style={{ width: "20%" }}>Amount</th>
                <th className="masterHeader"  style={{ width: "5%" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {memberships.length > 0 ? (
                memberships.map((membership, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{membership.subscriptionCode}</td>
                    <td>{membership.subscriptionName}</td>
                    <td>
                    {
                     membership.subscriptionType
                     ? (subscriptionDurationOptions.find(opt => opt.value === membership.subscriptionType)?.label || membership.subscriptionType)
                     : "N/A"
                    }
                    </td>
                    <td style={{textlign: "justify" }}>{membership.subscriptionAmount}</td>
                    <td>
                      <button
                        className="btn btn-warning"
                        onClick={() => handleEditClick(membership)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
          </div>
        </div>
        <div><br></br>
          <button className="btn add btn-name" onClick={() => toggleModal('Add')}>
            Add
          </button>
        </div><br></br>
        {showModal && (
          <>
            {/* Backdrop */}
            <div
              className={`modal-backdrop fade ${modalVisible ? 'show' : ''}`}
              onClick={() => toggleModal("")} // Close modal when clicking backdrop
              style={{ zIndex: 1040 }} // Ensure backdrop is behind modal
            ></div>
            <div className={`modal fade show modal-show-custom ${modalVisible ? 'modal-visible' : ''}`} style={{ display: 'block' }} aria-modal="true" role="dialog">
              <div className="modal-dialog modal-lg modal-lg-custom">
                <div className="modal-content modal-content-custom">
                  <div className="modal-header d-flex justify-content-between  text-white modal-header-custom">
                    <h5 className="modal-title">Membership Type {actionFrom}</h5>
                    <button type="button" className="btn btn-danger modal-header-danger-custom" onClick={() => toggleModal("")} aria-label="Close">
                      <span aria-hidden="true">&times;</span> 
                    </button>
                  </div>

                  <div className="modal-body">
                    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                      {({ errors, touched, handleChange, handleBlur, values, setFieldValue,setFieldTouched,setFieldError }) => (
                        <Form>
                          <div className="row">
                          <div className="col-md-6 mb-3 p-2">
                            <div className="form-floating">  
                                <Field
                                  className="form-control"
                                  id="subscriptionCode"
                                  label="Membership Code"
                                  size="small"
                                  type="text"
                                  margin="normal"
                                  name="subscriptionCode"  
                                  placeholder="Enter Membership Code"
                                  maxLength="2"
                                  onBlur={(e) => {
                                    handleBlur(e);
                                    handleSubscriptionCodeBlur(e, setFieldValue, setFieldError)
                                  }}
                                  onChange={handleChange}
                                  error={Boolean(touched.subscriptionCode && errors.subscriptionCode)}
                                  helperText={touched.subscriptionCode && errors.subscriptionCode}
                                  disabled={!isEditable}
                                  InputProps={{
                                    autoComplete: "off",
                                  }}
                                  style={{ marginTop: "0rem" }}
                                />
                              <label htmlFor="subscriptionCode">Membership Code<span className="required-input">*</span></label>
                              <ErrorMessage name="subscriptionCode" component="div" className="invalid-feedback" />
                            </div>
                            </div>
                            <div className="col-md-6 mb-3 p-2">
                              <div className="form-floating">
                                <Field
                                  className="form-control"
                                  id="subscriptionName"
                                  label="Membership Name"
                                  size="small"
                                  type="text"
                                  margin="normal"
                                  name="subscriptionName"  
                                  placeholder="Enter Membership Name" 
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={Boolean(touched.subscriptionName && errors.subscriptionName)}
                                  helperText={touched.subscriptionName && errors.subscriptionName}
                                  InputProps={{
                                    autoComplete: "off",
                                  }}
                                  style={{ marginTop: "0rem" }}
                                />
                              <label htmlFor="subscriptionName">Membership Name<span className="required-input">*</span></label>
                              <ErrorMessage name="subscriptionName" component="div" className="invalid-feedback" />
                            </div>
                          </div>

        
                            </div>
                            <div className="row">
                            <div className="col-md-6 mb-3 p-2">
                            <div className="form-floating">  
                                <Field
                                  className="form-control"
                                  id="subscriptionAmount"
                                  label="Membership Amount"
                                  size="small"
                                  type="number"
                                  margin="normal"
                                  name="subscriptionAmount"  
                                  placeholder="Enter Amount" 
                                  onChange={handleChange}
                                  onKeyDown={(e) => {
                                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  error={Boolean(touched.subscriptionAmount && errors.subscriptionAmount)}
                                  helperText={touched.subscriptionAmount && errors.subscriptionAmount}
                                  InputProps={{
                                    inputProps: { maxLength: 49 },
                                    autoComplete: "off",
                                  }}
                                  style={{ marginTop: "0rem" }}
                                />
                              <label htmlFor="subscriptionAmount">Membership Amount<span className="required-input">*</span></label>
                              <ErrorMessage name="subscriptionAmount" component="div" className="invalid-feedback" />
                              </div>
                            </div>
                            <div className="col-md-6 mb-3 p-2">
                              <SelectPicker
                                key={values.subscriptionType}
                                name="subscriptionType" 
                                options={subscriptionDurationOptions}
                                value={subscriptionDurationOptions.find((opt) => opt.value === values.subscriptionType) || null} 
                                handleChange={(selectedOption) => setFieldValue("subscriptionType", selectedOption?.value || "")}
                                label="Membership Type"
                                required={true}
                                error={touched.subscriptionType && errors.subscriptionType ? errors.subscriptionType : ""} 
                                touched={touched.subscriptionType}
                              setFieldTouched={setFieldTouched}
                              />
                              <ErrorMessage name="subscriptionType" component="div" className="invalid-feedback" />
                            </div>
                          </div>
                          <br></br><br></br>
                          <div className="d-flex justify-content-center mt-3">
                            {actionFrom === "Add" ? <button type="submit" className="btn btn-success" disabled={isDuplicate}>Submit</button> : <button type="submit" className="btn edit" disabled={isDuplicate}>Update</button>}
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
            <ConfirmationDialog
        open={openFeeConfirmationDialog}
        onClose={handleFeeDialogClose}
        onConfirm={handleFeeInfoDialogConfirm}
        title=""
        message= {isAddMode? "Are you sure to Add ?" : "Are you sure to Update ?"}
      />
          </>
        )}
      </main>
    </div>
  );
};

export default MembershipFeeComponent;
